"use strict";
(self["webpackChunkbulb_ngclient"] = self["webpackChunkbulb_ngclient"] || []).push([["src_app_menus_locale_en_json"],{

/***/ 47900:
/***/ ((module) => {

module.exports = JSON.parse('{"menuListPanel":{"moreOptions":"More Options"}}');

/***/ })

}]);